import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { BottomSheet, InputPhoneCertification } from '@encarpkg/design';
import useInquiry from 'app/hook/buyInquiry/useInquiry';
import useEnlog from 'app/hook/common/useEnlog';
import styles from './LayerPhoneCertify.module.scss';

const cx = classNames.bind(styles);

function LayerPhoneCertify({ onConfirm, onClose }) {
	const { phoneNumber } = useInquiry();
	const { enloggingJsonData } = useEnlog();

	useEffect(() => {
		const dataTalkViewSingle = {
			eventNameGroup: '전화번호인증',
		};
		enloggingJsonData({
			dataTalkViewSingle,
		});
	}, [enloggingJsonData]);

	return (
		<BottomSheet
			isOpen
			hasCloseBtn
			onClose={onClose}
			customStyles={{ padding: '20px' }}
			data-enlog-dt-eventnamegroup="전화번호인증"
		>
			<InputPhoneCertification
				site="buyInquiry"
				inBottomSheet
				defaultPhone={phoneNumber}
				title={
					<strong className={cx('tit')}>
						한번만 휴대전화번호 인증을 받으시면
						<br />
						계속 문의를 남길 수 있어요
					</strong>
				}
				disabled
				onSuccess={onConfirm}
				labelStyle={{ marginTop: '20px' }}
				data-enlog-dt-eventnamegroup="전화번호인증"
			/>
		</BottomSheet>
	);
}

export default LayerPhoneCertify;
